"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var apps_shared_1 = require("@l2p/apps-shared");
var ui_components_1 = require("@l2p/ui-components");
var Step1_1 = __importDefault(require("./Step1"));
var Step2_1 = __importDefault(require("./Step2"));
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var ForgotPasswordByPhone = function (_a) {
    var withLabels = _a.withLabels;
    var closeWindow = (0, apps_shared_1.useCloseModal)();
    var _b = (0, react_1.useState)(0), step = _b[0], setStep = _b[1];
    var _c = (0, react_1.useState)(null), resetPassToken = _c[0], setResetPassToken = _c[1];
    var setNextStep = (0, react_1.useCallback)(function () {
        setStep(step + 1);
    }, [setStep, step]);
    return (react_1.default.createElement(ui_components_1.Modal, { width: "360px", height: "auto", saveSize: true, onClose: closeWindow, overflowY: "visible" },
        react_1.default.createElement("div", { className: styles_module_scss_1.default.container }, step === 0 ? (react_1.default.createElement(Step1_1.default, { setNextStep: setNextStep, setResetPassToken: setResetPassToken })) : (react_1.default.createElement(Step2_1.default, { resetPassToken: resetPassToken, withLabels: withLabels })))));
};
exports.default = ForgotPasswordByPhone;
